import { render, staticRenderFns } from "./InlineFieldBlock.vue?vue&type=template&id=a0f28eb4"
import script from "./InlineFieldBlock.vue?vue&type=script&lang=ts"
export * from "./InlineFieldBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports